export type AdminCommsProbe = {
  status: 'ok' | 'unavailable' | 'skipped';
  detail: string | null;
};

export type AdminCommsStatus = {
  resend: {
    apiKeyConfigured: boolean;
    fromEmail: string;
    probe: AdminCommsProbe;
  };
  uazapi: {
    urlConfigured: boolean;
    tokenConfigured: boolean;
    systemTokenConfigured: boolean;
    probe: AdminCommsProbe;
    instanceCount: number | null;
  };
};

export type AdminEmailTemplateVariable = {
  name: string;
  description: string;
};

type AdminTemplateBase = {
  key: string;
  name: string;
  description: string;
  variables: AdminEmailTemplateVariable[];
  channel: string;
  deliveryActive: boolean;
  updatedAt: string;
  updatedBy: string | null;
};

export type AdminEmailTemplateRow = AdminTemplateBase & {
  subject: string;
  bodyHtml: string;
};

export type AdminEmailTemplateUpdate = Pick<AdminEmailTemplateRow, 'subject' | 'bodyHtml'>;

export type AdminWhatsappTemplateRow = AdminTemplateBase & {
  bodyText: string;
};

export function hasEnv(value: string | undefined | null): boolean {
  return Boolean(value && value.trim().length > 0);
}

export function interpolateTemplate(
  template: string,
  vars: Record<string, string | number | null | undefined>
): string {
  return template.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_m, key: string) => {
    const v = vars[key];
    if (v === null || v === undefined) return `{{${key}}}`;
    return String(v);
  });
}
